import { decodeBase64Url } from '@/base64-url/decodeBase64Url.js';

/**
 * Decodes the start parameter.
 * @see decodeBase64Url
 */
export const decodeStartParam = decodeBase64Url;